import { connect } from 'react-redux';
import { getTheme, getShowMatureContent, getIsLoggedIn, getCurrentUser, getPointsCount, getCsrfToken, getCurrentUserHasCore, getFeedbackUrl, getVerificationEmailAddress, getThemeSkin, getFragmentsBalance, getCoreLevel, getCoreExpires, getTierСount, getContentFilter } from '../publicSession/selectors';
import { toggleMature, toggleTheme, setTheme, setThemeSkin } from '../publicSession/actions';
import { userLogoutButtonClicked } from './redux/actions';
import { flagEnabled } from '../redux/flags/selectors';
import { pushModal, pushUserSettingsModal } from '../Modals/redux/actionCreators';
import { ModalType } from '../Modals/redux/types';
const mapStateToProps = (state)=>({
        csrfToken: getCsrfToken(state),
        currentUser: getCurrentUser(state),
        isLoggedIn: getIsLoggedIn(state),
        verificationEmail: getVerificationEmailAddress(state),
        theme: getTheme(state),
        themeSkin: getThemeSkin(state),
        matureContent: getShowMatureContent(state),
        contentFilter: getContentFilter(state),
        pointsCount: getPointsCount(state),
        fragmentsBalance: getFragmentsBalance(state),
        hasCoreMembership: getCurrentUserHasCore(state),
        coreLevel: getCoreLevel(state),
        coreExpires: getCoreExpires(state),
        feedbackUrl: getFeedbackUrl(state),
        hasSubscriptions: getTierСount(state) > 0,
        hasCryptoWallet: flagEnabled(state, 'crypto_wallet'),
        ai_generated: flagEnabled(state, 'ai_generated'),
        usermenu_core_entry_for_core_desktop: flagEnabled(state, 'usermenu_core_entry_for_core_desktop')
    });
const mapDispatchToProps = {
    toggleTheme,
    toggleMature,
    pushUserSettingsModal,
    setTheme,
    setThemeSkin,
    onUserLogoutButtonClicked: userLogoutButtonClicked,
    showWeb3WalletModal: ()=>pushModal(ModalType.WEB3_WALLET, {
            wrapInModal: false
        })
};
export default connect(mapStateToProps, mapDispatchToProps);
